<template>
  <div class="seckill-guide-mask-component">
    <ym-popup class="seckill-guide-mask-popup"
              v-model="visible"
              get-container="body"
              @click="handleClose"
    >
      <img class="seckill-guide-mask-image"
           :src="require('@/assets/img/seckill/guide_mask.jpg')"
           alt="无需刷新，倒计时结束点击即可秒杀"
      >
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import { setSeckillGuideMaskStorage } from '@/utils';

  export default {
    name: 'SeckillGuideMask',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
        setSeckillGuideMaskStorage();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-guide-mask {
    &-popup {
      width: 100%;
      max-width: unset;
    }

    &-image {
      width: 100%;
    }
  }
</style>
